import { GoPlus } from "react-icons/go";
import { Button } from "../../../../components/forms";
import { nodept } from "../../../../constant/import";
import { ListPicker } from "../../../../components/generic/ListPicker";
import { usePickerhook } from "../../../../hooks/usePickerhook";
import { useState } from "react";
import Switch from "react-switch";
import { countries } from "../../../../constant/data";
import AddHolidayModal from "../../../../components/Modules/Employees/AddHolidayModal";
import useCalendarHook from "../../../../hooks/useCalendarHook";
import { FaRegCalendarDays } from "react-icons/fa6";
import { IoReceipt } from "react-icons/io5";

export default ({ setshowadddept, leaves, refresh }: any) => {
  const EmptyList = () => (
    <div className=" mx-6 p-5 scale-[.75]   text-textbg flex flex-col justify-center rounded-xl items-center border border-gray-300 ">
      <img src={nodept} />
      <p className="font-bold">No Holidays</p>
      <small>No Holiday has been added</small>

      <Button
        width={200}
        disabled={false}
        text={
          <>
            <GoPlus size={15} className=" mx-1 inline" /> Add Holiday
          </>
        }
        onBtnClick={() => {
          setshowaddHoliday(true);
        }}
      />
    </div>
  );

  const [enablecountryconf, setenablecountryconf] = useState(false);
  const [showaddHoliday, setshowaddHoliday] = useState(false);
  const weekendpickedhook = usePickerhook();
  const { GetOrgHolidays, holidays, AddHoliday } = useCalendarHook();

  return (
    <div className=" ">
      {showaddHoliday && (
        <AddHolidayModal
          AddHoliday={AddHoliday}
          refresh={GetOrgHolidays}
          show={setshowaddHoliday}
        />
      )}
      <div className="flex justify-between p-2 border items-center border-1 border-gray-200 rounded ">
        <p className="text-textbg font-medium text-sm mb-2 text-[16px]  bg-white">
          Holiday ({holidays.length})
        </p>

        <Button
          text="Add Holiday"
          width={200}
          onBtnClick={() => {
            setshowaddHoliday(true);
          }}
        />
      </div>

      <div className="flex justify-between items-center mt-4 ">
        <div>
          <p className="font-semibold text-lg ">Region-Specific</p>
          <p className=" font-light text-xs ">
            Options to apply region-specific configurations for different
            locations
          </p>
        </div>
        <Switch
          checkedIcon={false}
          uncheckedIcon={false}
          offColor="#EAECF5"
          onColor="#CB0E5F"
          className="m-4"
          onChange={async () => {
            setenablecountryconf((prev) => !prev);
          }}
          checked={enablecountryconf}
        />
      </div>

      {enablecountryconf && (
        <div className="flex justify-between items-center ">
          <p className=" font-light  ">Country</p>
          <ListPicker
            hook={weekendpickedhook}
            notitle
            title="Country"
            list={countries}
          />
        </div>
      )}

      <div className="  py-2 grid grid-cols-2 gap-4 ">
        {holidays.map((item: any) => (
          <HolidayItem item={item} />
        ))}
      </div>
    </div>
  );
};

const HolidayItem = ({ item }: any) => (
  <div className=" border border-gray-200 border-1 p-4 gap-2 rounded-[10px] text-gray-400 ">
    <p className="text-gray-500 font-semibold mb-2">{item.title}</p>
    <p className="flex gap-2 text-sm">
      <FaRegCalendarDays
        size={20}
        className="inline rounded  p-1 bg-gray-500 text-white"
      />
      {new Date(item.startDate).toDateString()} -{" "}
      {new Date(item.endDate).toDateString()}    <IoReceipt className="text-textbg inline  " />{item.contractType}
    </p>
  </div>
);
